









import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  components: {}
})
class App4PageNotFound extends Vue {

}

export default App4PageNotFound
